import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Panel from 'components/Panel/Panel';

import styles from './PublicQuestion.module.scss';

const PublicQuestion = ({ onAnswer, postingAnswer, question }) => {
  const [answering, setAnswering] = useState(false);
  const [currentAnswer, setCurrentAnswer] = useState(question.answer);

  useEffect(() => {
    if (question.answer !== currentAnswer) {
      setAnswering(false);
    }
  }, [question.answer]);

  const handleAnswerInputChange = (event) => {
    setCurrentAnswer(event.target.value);
  };

  const handleAnswerNowClick = () => {
    setAnswering(true);
  };

  const handleCancelClick = () => {
    setAnswering(false);
    setCurrentAnswer(question.answer);
  };

  const handleSaveClick = () => {
    onAnswer(question, currentAnswer);
  };

  return (
    <Panel className={styles.container}>
      <p>
        <strong>Q: {question.question}</strong>{' '}
        {question.answer && !answering ? (
          <em>
            -{' '}
            <a onClick={handleAnswerNowClick} title="Edit answer">
              edit answer
            </a>
          </em>
        ) : (
          ''
        )}
      </p>
      <p>
        A:{' '}
        {question.answer ? (
          question.answer
        ) : (
          <em>
            Not answered yet.{' '}
            {!answering && (
              <a onClick={handleAnswerNowClick} title="Answer now">
                Answer now
              </a>
            )}
          </em>
        )}
      </p>
      {answering && (
        <div>
          <textarea
            rows="4"
            className="form-control"
            maxLength="1000"
            placeholder="Enter your answer and click Save"
            disabled={postingAnswer}
            value={currentAnswer}
            onChange={handleAnswerInputChange}
          />
          {currentAnswer.length > 800 && (
            <div>
              <em>Characters left: {1000 - currentAnswer.length}</em>
            </div>
          )}
          <Button
            bsStyle="info"
            disabled={postingAnswer}
            onClick={handleCancelClick}
          >
            Cancel
          </Button>
          <Button
            bsStyle="success"
            disabled={currentAnswer === '' || postingAnswer}
            onClick={handleSaveClick}
          >
            Save
          </Button>
        </div>
      )}
    </Panel>
  );
};

PublicQuestion.propTypes = {
  onAnswer: PropTypes.func,
  postingAnswer: PropTypes.bool,
  question: PropTypes.object,
};
export default PublicQuestion;
